
const terminalSettingsUtils = require('./terminalSettingsUtils');
const stringUtil = require('../../string/stringUtil');

module.exports.getNewOrderSoundVolume = function()
{
    if (stringUtil.isStringNullOrEmpty(terminalSettingsUtils.getSoundSettings().newOrderSoundVolume))
        return 1;

    return terminalSettingsUtils.getSoundSettings().newOrderSoundVolume * 1;
}

module.exports.setNewOrderSoundVolume = function(volume)
{
    volume = parseFloat((volume * 1).toFixed(1));
    terminalSettingsUtils.getSoundSettings().newOrderSoundVolume  = volume * 1;
    terminalSettingsUtils.saveSettings();
}
